"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @export
 * @enum {string}
 */
var MetaformTableColumnType;
(function (MetaformTableColumnType) {
    MetaformTableColumnType["Hidden"] = "hidden";
    MetaformTableColumnType["Text"] = "text";
    MetaformTableColumnType["Url"] = "url";
    MetaformTableColumnType["Email"] = "email";
    MetaformTableColumnType["Autocomplete"] = "autocomplete";
    MetaformTableColumnType["Number"] = "number";
    MetaformTableColumnType["Enum"] = "enum";
    MetaformTableColumnType["Date"] = "date";
    MetaformTableColumnType["Time"] = "time";
    MetaformTableColumnType["Html"] = "html";
    MetaformTableColumnType["Button"] = "button";
})(MetaformTableColumnType = exports.MetaformTableColumnType || (exports.MetaformTableColumnType = {}));
function MetaformTableColumnTypeFromJSON(json) {
    return MetaformTableColumnTypeFromJSONTyped(json, false);
}
exports.MetaformTableColumnTypeFromJSON = MetaformTableColumnTypeFromJSON;
function MetaformTableColumnTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.MetaformTableColumnTypeFromJSONTyped = MetaformTableColumnTypeFromJSONTyped;
function MetaformTableColumnTypeToJSON(value) {
    return value;
}
exports.MetaformTableColumnTypeToJSON = MetaformTableColumnTypeToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1UYWJsZUNvbHVtblR5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvTWV0YWZvcm1UYWJsZUNvbHVtblR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSDs7OztHQUlHO0FBQ0gsSUFBWSx1QkFZWDtBQVpELFdBQVksdUJBQXVCO0lBQy9CLDRDQUFpQixDQUFBO0lBQ2pCLHdDQUFhLENBQUE7SUFDYixzQ0FBVyxDQUFBO0lBQ1gsMENBQWUsQ0FBQTtJQUNmLHdEQUE2QixDQUFBO0lBQzdCLDRDQUFpQixDQUFBO0lBQ2pCLHdDQUFhLENBQUE7SUFDYix3Q0FBYSxDQUFBO0lBQ2Isd0NBQWEsQ0FBQTtJQUNiLHdDQUFhLENBQUE7SUFDYiw0Q0FBaUIsQ0FBQTtBQUNyQixDQUFDLEVBWlcsdUJBQXVCLEdBQXZCLCtCQUF1QixLQUF2QiwrQkFBdUIsUUFZbEM7QUFFRCxTQUFnQiwrQkFBK0IsQ0FBQyxJQUFTO0lBQ3JELE9BQU8sb0NBQW9DLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQzdELENBQUM7QUFGRCwwRUFFQztBQUVELFNBQWdCLG9DQUFvQyxDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDeEYsT0FBTyxJQUErQixDQUFDO0FBQzNDLENBQUM7QUFGRCxvRkFFQztBQUVELFNBQWdCLDZCQUE2QixDQUFDLEtBQXNDO0lBQ2hGLE9BQU8sS0FBWSxDQUFDO0FBQ3hCLENBQUM7QUFGRCxzRUFFQyJ9